// extracted by mini-css-extract-plugin
export default {"bestOffer":"best_offer_bestOffer__X65Cn"};